import { AIIntent, AIOutcome } from '@weave/schema-gen-ts/dist/shared/phone/v1/callrecord/enums.pb';
import { i18next } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { getAIIntentLabel } from '@frontend/phone-ui';
import { Text, Chip } from '@frontend/design-system';
import { formatTime } from '../../utils/get-event-accordion-body';
import { EventRenderer } from '../../utils/render-event';
import { AccordionEvent } from '../../utils/render-event-accordion';
import { EventBox } from '../event-renderer-item';
import { FallbackChip } from '../fallback.component';

export const renderAIAgent: EventRenderer = (event, { callerName, isSecondToLast }) => {
  if (!('aiReceptionistEvent' in event)) return null;
  const {
    createdAt,
    aiReceptionistEvent: { actionType, callerIntent, reason },
  } = event;
  const showFallbackChip = actionType !== AIOutcome.AI_OUTCOME_END_CALL && !isSecondToLast;
  const isEarlyFatalError = actionType === AIOutcome.AI_OUTCOME_FATAL && callerIntent === AIIntent.AI_INTENT_UNKNOWN;
  const startTime = formatTime(createdAt);
  const intent = callerIntent && getAIIntentLabel(callerIntent);
  const subtitle = intent && (
    <Chip.Category
      tooltipLabel={i18next.t('Caller Intent', { ns: 'calls' })}
      leftElement={<Icon name='aiassistant-small' css={{ color: intent.indicatorColor }} />}
    >
      {intent.name}
    </Chip.Category>
  );

  const fatalSubtitle = isEarlyFatalError && (
    <Text size='medium' color='error'>
      {reason}
    </Text>
  );

  const content = (
    <EventBox
      key={actionType}
      iconName='aiweave-assistant'
      title={i18next.t('AI Receptionist', { ns: 'calls' })}
      subtitle={isEarlyFatalError ? fatalSubtitle : subtitle}
      endAdornment={startTime}
      hideBoxShadow={!isEarlyFatalError}
    />
  );

  return (
    <>
      {isEarlyFatalError ? (
        content
      ) : (
        <AccordionEvent event={event} callerName={callerName} eventKey={actionType}>
          {content}
        </AccordionEvent>
      )}
      {showFallbackChip && (
        <div className='event-box-item' css={{ textAlign: 'center', position: 'relative' }}>
          <FallbackChip />
        </div>
      )}
    </>
  );
};
